module.exports = __webpack_public_path__ + "img/icon7.d44cd0d5.svg";